import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { isWebView2 } from '@office-start/device-detection-utility';
import { OfficeWorkload } from '@office-start/officehome-types';
var launchNativeFileFuncs = undefined;
export function getLaunchFunctions() {
    return __awaiter(this, void 0, void 0, function () {
        var context_1, useHwaLaunch;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!launchNativeFileFuncs) return [3 /*break*/, 4];
                    return [4 /*yield*/, fetchOfficeComponentContext()];
                case 1:
                    context_1 = _a.sent();
                    useHwaLaunch = context_1.workload === OfficeWorkload.Hwa || isWebView2();
                    if (!useHwaLaunch) return [3 /*break*/, 3];
                    return [4 /*yield*/, import(
                        /* webpackChunkName: "hwalaunchfile" */ '../hwaLaunchFile').then(function (module) { return ({
                            launchFile: module.getLaunchFileFunc(context_1),
                            launchInDesktopApps: module.launchInDesktopApps,
                            launchTemplate: module.launchTemplate,
                            openFileInExplorer: module.openFileInExplorer,
                        }); })];
                case 2:
                    launchNativeFileFuncs = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    launchNativeFileFuncs = {
                        launchFile: function () { return Promise.reject(); },
                        launchInDesktopApps: function () { return Promise.reject(); },
                        launchTemplate: function () { return Promise.reject(); },
                        openFileInExplorer: function () { return Promise.reject(); },
                    };
                    _a.label = 4;
                case 4: 
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return [2 /*return*/, launchNativeFileFuncs];
            }
        });
    });
}
//# sourceMappingURL=getLaunchFileFunctions.js.map